<div>Version: {{version.version}}</div>
<div>
    <a href="https://github.com/edutone/connect-ui/commits/{{version.branch}}" target="_blank">{{version.branch}}</a>:
    <a href="https://github.com/edutone/connect-ui/commit/{{version.revision}}" target="_blank">{{version.revision_short}}</a>
    , updated {{version.date}}.
</div>
